import { defineStyleConfig } from "@chakra-ui/styled-system";
import { textStyles } from "theme/text-styles";

export const FormLabel = defineStyleConfig({
  baseStyle: {
    ...textStyles.label,
    mb: "1",
  },
});
